import { Code2, Globe, MessageCircle, Telescope } from "lucide-react";
import { apiFetch } from "@/lib/api";
import { readSSE } from "@/lib/sse";

export const DEPTHS = {
  quick: { label: "Fast Search", short: "Fast", icon: Globe, blurb: "One focused web search, ~6 sources. Usually under a minute." },
  deep: { label: "Deep Search", short: "Deep", icon: Telescope, blurb: "Several searches, reads full pages, ~10–14 sources. 1–3 minutes, uses more credits." },
};

// Composer modes. Search modes map onto research depths on the server.
export const MODES = {
  chat: { key: "chat", label: "Chat", icon: MessageCircle, blurb: "Talk with ChatSleek. Works with your files and projects.", placeholder: null, send: "Send message" },
  code: { key: "code", label: "Sleek Code", icon: Code2, chatMode: "code", blurb: "Writes, reviews and explains code. Code isn't run.", placeholder: "Describe the code you need…", send: "Send" },
  fast: { key: "fast", label: "Fast Search", icon: Globe, depth: "quick", blurb: "Searches the live web and answers with cited sources. Files aren't used.", placeholder: "Search the web…", send: "Search" },
  deep: { key: "deep", label: "Deep Search", icon: Telescope, depth: "deep", blurb: "Plans several searches, reads full pages and writes a cited report. Takes 1–3 minutes and uses more credits.", placeholder: "What should ChatSleek research in depth?", send: "Start Deep Search" },
};
export const MODE_ORDER = ["chat", "fast", "deep", "code"];

const STAGES = [
  { key: "preparing", label: "Preparing" },
  { key: "planning", label: "Planning searches" },
  { key: "searching", label: "Searching the web" },
  { key: "analyzing", label: "Reading sources" },
  { key: "writing", label: "Writing report" },
];

export function stagesFor(depth, plan, stage) {
  return STAGES.filter((s) => (s.key === "planning" ? depth === "deep" || plan?.length > 0 || stage === "planning" : s.key === "analyzing" ? depth === "deep" : true));
}

export const STATUS_LABELS = { running: "Running", complete: "Complete", failed: "Failed", cancelled: "Stopped" };

export async function streamResearch(sessionId, onEvent, signal) {
  const res = await apiFetch(`/research/sessions/${sessionId}/events`, { raw: true, signal });
  for await (const { event, data } of readSSE(res)) onEvent(event, data);
}

// Turns [3] / [1][4] markers into links the report renderer swaps for citation chips.
export const linkCitations = (text) => (text || "").replace(/\[(\d{1,3})\](?!\()/g, "[$1](#cite-$1)");

export const citedSet = (text) => new Set([...(text || "").matchAll(/\[(\d{1,3})\](?!\()/g)].map((m) => Number(m[1])));

export const plural = (n, word) => `${n} ${word}${n === 1 ? "" : /(s|x|z|ch|sh)$/i.test(word) ? "es" : "s"}`;
